import { observer } from 'mobx-react';
import cls from 'classnames';

import { DriveTreeItem } from '@/drive/entities/DriveTreeItem/DriveTreeItem';
import DriveModalTreeItemMeta from '@/forwarding/components/ForwardModal/ForwardModalBody/DriveModalTree/BaseDriveModalTree/DriveModalTreeItemMeta/DriveModalTreeItemMeta';
import DriveModalTreeItemPreview from '@/forwarding/components/ForwardModal/ForwardModalBody/DriveModalTree/BaseDriveModalTree/DriveModalTreeItemPreview/DriveModalTreeItemPreview';

import styles from './RecentDestinationItem.module.css';

export interface RecentDestinationItemProps {
  item: DriveTreeItem;
  isSelected: boolean;
  ariaLabel?: string;
  onSelect?: () => void;
}

function RecentDestinationItem(props: RecentDestinationItemProps) {
  const { item, isSelected, ariaLabel, onSelect } = props;

  return (
    <div
      className={cls(styles.recentDestinationItem, { [styles.selected]: isSelected })}
      aria-label={ariaLabel}
      onClick={onSelect}
    >
      <DriveModalTreeItemPreview item={item} />

      <div className={styles.content}>
        <span aria-label="Destination title">{item.title}</span>

        <DriveModalTreeItemMeta item={item} />
      </div>
    </div>
  );
}

export default observer(RecentDestinationItem);
